(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    // Auto-scale messages to fit on one line
    // Message rotation
    var messages = bar.querySelectorAll('.announcement-bar__message');
    if (messages.length > 1) {
      var currentIndex = 0;
      setInterval(function() {
        messages[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % messages.length;
        messages[currentIndex].classList.add('is-active');
      }, 4000);
    }

    // Free shipping dynamic update
    var shippingMsg = bar.querySelector('[data-free-shipping-msg]');
    if (shippingMsg) {
      var threshold = parseInt(shippingMsg.getAttribute('data-threshold'), 10);

      function formatMoney(cents) {
        var a = cents / 100;
        var f = window.__mf || {p:'',s:'',t:',',d:'.'};
        if (f.zd) { var _i = Math.round(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, f.t); return f.p + _i + f.s; }
        var p = a.toFixed(2).split('.');
        var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.t);
        return f.p + i + f.d + p[1] + f.s;
      }

      function updateShippingMsg(cartTotal) {
        var remaining = threshold - cartTotal;
        if (remaining > 0) {
          shippingMsg.innerHTML = "YOU'RE <strong>" + formatMoney(remaining) + "</strong> AWAY FOR FREE SHIPPING";
        } else {
          shippingMsg.innerHTML = "CONGRATULATIONS! YOUR ORDER QUALIFIES FOR <strong>FREE SHIPPING</strong>";
        }
      }

      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateShippingMsg(cart.total_price);
      });

      var origFetch = window.fetch;
      window.fetch = function() {
        var args = arguments;
        return origFetch.apply(this, args).then(function(response) {
          var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
          if (url.indexOf('/cart') !== -1) {
            setTimeout(function() {
              origFetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                updateShippingMsg(cart.total_price);
              });
            }, 300);
          }
          return response;
        });
      };
    }

    // Country selector UI
    var selector = bar.querySelector('[data-country-selector]');
    var toggle = selector ? selector.querySelector('[data-country-toggle]') : null;
    var mobileSelector = document.querySelector('[data-country-selector-mobile]');
    var mobileToggle = mobileSelector ? mobileSelector.querySelector('[data-country-toggle-mobile]') : null;
    var dropdown = document.querySelector('[data-country-dropdown]');

    if (dropdown) {
      if (dropdown.parentNode !== document.body) document.body.appendChild(dropdown);
      var searchInput = dropdown.querySelector('[data-country-search]');
      var options = dropdown.querySelectorAll('[data-country-option]');
      var activeToggle = toggle;

      function positionDropdown() {
        if (!activeToggle) return;
        var rect = activeToggle.getBoundingClientRect();
        dropdown.style.top = (rect.bottom + 6) + 'px';
        dropdown.style.right = (window.innerWidth - rect.right) + 'px';
        dropdown.style.left = 'auto';
      }

      function openDropdown(tgl) {
        activeToggle = tgl || toggle;
        positionDropdown();
        dropdown.hidden = false;
        if (selector && activeToggle === toggle) selector.classList.add('is-open');
        if (mobileSelector && activeToggle === mobileToggle) mobileSelector.classList.add('is-open');
        if (activeToggle) activeToggle.setAttribute('aria-expanded', 'true');
        if (searchInput) { searchInput.value = ''; filterOptions(''); setTimeout(function() { searchInput.focus(); }, 50); }
      }

      function closeDropdown() {
        dropdown.hidden = true;
        if (selector) selector.classList.remove('is-open');
        if (mobileSelector) mobileSelector.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      }

      if (toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          if (dropdown.hidden) { openDropdown(toggle); } else { closeDropdown(); }
        });
      }

      if (mobileToggle) {
        mobileToggle.addEventListener('click', function(e) {
          e.preventDefault();
          if (dropdown.hidden) { openDropdown(mobileToggle); } else { closeDropdown(); }
        });
      }

      document.addEventListener('click', function(e) {
        if (dropdown.hidden) return;
        var inSelector = selector && selector.contains(e.target);
        var inDropdown = dropdown.contains(e.target);
        var inMobile = mobileSelector && mobileSelector.contains(e.target);
        if (!inSelector && !inDropdown && !inMobile) closeDropdown();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeDropdown();
      });

      window.addEventListener('scroll', function() {
        if (!dropdown.hidden) positionDropdown();
      }, { passive: true });
      window.addEventListener('resize', function() {
        if (!dropdown.hidden) positionDropdown();
      });

      function filterOptions(query) {
        var q = query.toLowerCase().trim();
        options.forEach(function(opt) {
          var name = opt.getAttribute('data-country-name') || '';
          opt.hidden = q && name.indexOf(q) === -1;
        });
      }

      if (searchInput) {
        searchInput.addEventListener('input', function() {
          filterOptions(this.value);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initBestSellers(section) {
    var sectionId = section.dataset.sectionId;
    var tabs = section.querySelectorAll('.best-sellers__tab[data-section="' + sectionId + '"]');
    var carousels = section.querySelectorAll('.best-sellers__carousel[data-section="' + sectionId + '"]');
    var prevBtn = section.querySelector('.best-sellers__arrow--prev[data-section="' + sectionId + '"]');
    var nextBtn = section.querySelector('.best-sellers__arrow--next[data-section="' + sectionId + '"]');

    var toggle = section.querySelector('.best-sellers__toggle[data-section="' + sectionId + '"]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.dataset.tab;
        tabs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (toggle) toggle.setAttribute('data-active', target);
        carousels.forEach(function(c) {
          c.classList.remove('active');
          if (c.dataset.carousel === target) {
            c.classList.add('active');
          }
        });
      });
    });

    function getActiveTrack() {
      var activeCarousel = section.querySelector('.best-sellers__carousel.active');
      return activeCarousel ? activeCarousel.querySelector('.best-sellers__track') : null;
    }

    function getScrollAmount() {
      var card = section.querySelector('.bs-product-card');
      if (card) {
        return (card.offsetWidth + 12) * 3;
      }
      return 600;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var track = getActiveTrack();
        if (track) {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var track = getActiveTrack();
        if (track) {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      });
    }
  }

  document.querySelectorAll('.best-sellers').forEach(initBestSellers);

  document.addEventListener('mouseover', function(e) {
    var swatch = e.target.closest('.best-sellers [data-swatch-image]');
    if (!swatch) return;
    var card = swatch.closest('[data-product-card]');
    if (!card) return;
    var img = card.querySelector('.bs-product-card__image');
    var colorEl = card.querySelector('.bs-product-card__color');
    var nameLink = card.querySelector('.bs-product-card__name');
    if (img && swatch.dataset.swatchImage) {
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.src;
        img.dataset.originalSrcset = img.srcset || '';
      }
      img.srcset = '';
      img.src = swatch.dataset.swatchImage;
    }
    if (colorEl && swatch.dataset.swatchColor) {
      if (!colorEl.dataset.originalText) colorEl.dataset.originalText = colorEl.textContent;
      colorEl.textContent = swatch.dataset.swatchColor;
    }
    if (nameLink && swatch.dataset.swatchUrl) {
      if (!nameLink.dataset.originalHref) nameLink.dataset.originalHref = nameLink.href;
      nameLink.href = swatch.dataset.swatchUrl;
    }
  });

  document.addEventListener('mouseleave', function(e) {
    if (!e.target.classList || !e.target.classList.contains('bs-product-card__swatches')) return;
    var card = e.target.closest('[data-product-card]');
    if (!card) return;
    var img = card.querySelector('.bs-product-card__image');
    var colorEl = card.querySelector('.bs-product-card__color');
    var nameLink = card.querySelector('.bs-product-card__name');
    if (img && img.dataset.originalSrc) {
      img.src = img.dataset.originalSrc;
      img.srcset = img.dataset.originalSrcset || '';
    }
    if (colorEl && colorEl.dataset.originalText) colorEl.textContent = colorEl.dataset.originalText;
    if (nameLink && nameLink.dataset.originalHref) nameLink.href = nameLink.dataset.originalHref;
  }, true);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.best-sellers');
      if (section) initBestSellers(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function() {
  /* Custom sort dropdowns */
  function initSort(toggleSel, dropdownSel) {
    var btn = document.querySelector(toggleSel);
    var dd = document.querySelector(dropdownSel);
    if (!btn || !dd) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = dd.classList.contains('is-open');
      closeAllSorts();
      if (!open) {
        dd.classList.add('is-open');
        btn.classList.add('is-open');
      }
    });
    dd.querySelectorAll('[data-sort-value]').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', this.dataset.sortValue);
        window.location.href = u.toString();
      });
    });
  }
  function closeAllSorts() {
    document.querySelectorAll('.dr-sort__dropdown').forEach(function(d) { d.classList.remove('is-open'); });
    document.querySelectorAll('.dr-sort__btn, [data-sort-toggle-mobile]').forEach(function(b) { b.classList.remove('is-open'); });
  }
  document.addEventListener('click', closeAllSorts);
  initSort('[data-sort-toggle]', '[data-sort-dropdown]');
  initSort('[data-sort-toggle-mobile]', '[data-sort-dropdown-mobile]');

  /* Filter section toggles */
  document.querySelectorAll('[data-filter-toggle]').forEach(function(toggle) {
    var body = toggle.nextElementSibling;
    if (body && toggle.getAttribute('aria-expanded') === 'true') {
      body.style.maxHeight = body.scrollHeight + 'px';
    }
    toggle.addEventListener('click', function() {
      var exp = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !exp);
      var b = this.nextElementSibling;
      if (!b) return;
      if (!exp) { b.style.maxHeight = b.scrollHeight + 'px'; }
      else { b.style.maxHeight = '0'; }
    });
  });

  /* Mobile filter drawer */
  var sidebar = document.getElementById('DrSidebar');
  var backdrop = document.querySelector('[data-filter-backdrop]');
  var openBtn = document.querySelector('[data-mobile-filter-toggle]');
  var closeBtn = document.querySelector('[data-filter-close]');
  function openDrawer() {
    if (!sidebar || !backdrop) return;
    sidebar.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!sidebar || !backdrop) return;
    sidebar.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  /* Price range slider */
  function _fmtPrice(cents) {
    var a = cents / 100;
    var f = window.__mf || {p:'',s:'',t:',',d:'.'};
    if (f.zd) { var _i = Math.round(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, f.t); return f.p + _i + f.s; }
    var p = a.toFixed(2).split('.');
    var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.t);
    return f.p + i + f.d + p[1] + f.s;
  }
  document.querySelectorAll('[data-price-slider]').forEach(function(slider) {
    var minR = slider.querySelector('[data-price-range-min]');
    var maxR = slider.querySelector('[data-price-range-max]');
    var fill = slider.querySelector('[data-price-fill]');
    var container = slider.closest('.dr-filter__body');
    var minLabel = container.querySelector('[data-price-label-min]');
    var maxLabel = container.querySelector('[data-price-label-max]');
    var minInput = container.querySelector('[data-price-input-min]');
    var maxInput = container.querySelector('[data-price-input-max]');
    var rangeMax = parseFloat(slider.dataset.rangeMax) || 200;

    function updateFill() {
      var lo = parseFloat(minR.value);
      var hi = parseFloat(maxR.value);
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      var pctL = (lo / rangeMax) * 100;
      var pctR = (hi / rangeMax) * 100;
      fill.style.left = pctL + '%';
      fill.style.width = (pctR - pctL) + '%';
      minLabel.textContent = _fmtPrice(Math.floor(lo) * 100);
      maxLabel.textContent = _fmtPrice(Math.floor(hi) * 100);
    }
    updateFill();

    var priceTimer;
    function onSlide() {
      updateFill();
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function() {
        var lo = Math.min(parseFloat(minR.value), parseFloat(maxR.value));
        var hi = Math.max(parseFloat(minR.value), parseFloat(maxR.value));
        var u = new URL(window.location.href);
        var del = [];
        u.searchParams.forEach(function(v, k) { if (k.startsWith('filter.v.price')) del.push(k); });
        del.forEach(function(k) { u.searchParams.delete(k); });
        if (lo > 0) u.searchParams.set(minInput.name, lo);
        if (hi < rangeMax) u.searchParams.set(maxInput.name, hi);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      }, 600);
    }
    minR.addEventListener('input', onSlide);
    maxR.addEventListener('input', onSlide);
  });

  /* Filter form (checkboxes) — query checked boxes directly, never include price hidden inputs */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var checkboxes = filterForm.querySelectorAll('input[type="checkbox"][data-filter-input]');
    var timer;
    checkboxes.forEach(function(input) {
      input.addEventListener('change', function() {
        clearTimeout(timer);
        timer = setTimeout(function() {
          var u = new URL(window.location.href);
          var del = [];
          u.searchParams.forEach(function(v, k) {
            if (k.startsWith('filter.') && k.indexOf('price') === -1) del.push(k);
          });
          del.forEach(function(k) { u.searchParams.delete(k); });
          filterForm.querySelectorAll('input[type="checkbox"][data-filter-input]:checked').forEach(function(cb) {
            u.searchParams.append(cb.name, cb.value);
          });
          u.searchParams.delete('page');
          window.location.href = u.toString();
        }, 300);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-block"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionId = '{{ section.id }}';
    var formWrap = document.getElementById('drop-form-' + sectionId);
    var successWrap = document.getElementById('drop-success-' + sectionId);

    if (!formWrap) return;

    var form = formWrap.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      }).then(function() {
        formWrap.style.display = 'none';
        successWrap.style.display = 'block';
      }).catch(function() {
        formWrap.style.display = 'none';
        successWrap.style.display = 'block';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFeaturedCollection(section) {
    var sectionId = section.dataset.sectionId;
    var tabs = section.querySelectorAll('.featured-collection__tab[data-section="' + sectionId + '"]');
    var carousels = section.querySelectorAll('.featured-collection__carousel[data-section="' + sectionId + '"]');
    var prevBtn = section.querySelector('.featured-collection__arrow--prev[data-section="' + sectionId + '"]');
    var nextBtn = section.querySelector('.featured-collection__arrow--next[data-section="' + sectionId + '"]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.dataset.tab;
        tabs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        carousels.forEach(function(c) {
          c.classList.remove('active');
          if (c.dataset.carousel === target) {
            c.classList.add('active');
          }
        });
      });
    });

    function getActiveTrack() {
      var activeCarousel = section.querySelector('.featured-collection__carousel.active');
      return activeCarousel ? activeCarousel.querySelector('.featured-collection__track') : null;
    }

    function getScrollAmount() {
      var card = section.querySelector('.product-card');
      if (card) {
        return (card.offsetWidth + 12) * 3;
      }
      return 600;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var track = getActiveTrack();
        if (track) {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var track = getActiveTrack();
        if (track) {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      });
    }
  }

  document.querySelectorAll('.featured-collection').forEach(initFeaturedCollection);

  document.addEventListener('mouseover', function(e) {
    var swatch = e.target.closest('[data-swatch-image]');
    if (!swatch) return;
    var card = swatch.closest('[data-product-card]');
    if (!card) return;
    var img = card.querySelector('.product-card__image');
    var colorEl = card.querySelector('.product-card__color');
    var nameLink = card.querySelector('.product-card__name');
    if (img && swatch.dataset.swatchImage) {
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.src;
        img.dataset.originalSrcset = img.srcset || '';
      }
      img.srcset = '';
      img.src = swatch.dataset.swatchImage;
    }
    if (colorEl && swatch.dataset.swatchColor) {
      if (!colorEl.dataset.originalText) colorEl.dataset.originalText = colorEl.textContent;
      colorEl.textContent = swatch.dataset.swatchColor;
    }
    if (nameLink && swatch.dataset.swatchUrl) {
      if (!nameLink.dataset.originalHref) nameLink.dataset.originalHref = nameLink.href;
      nameLink.href = swatch.dataset.swatchUrl;
    }
  });

  document.addEventListener('mouseleave', function(e) {
    if (!e.target.classList || !e.target.classList.contains('product-card__swatches')) return;
    var card = e.target.closest('[data-product-card]');
    if (!card) return;
    var img = card.querySelector('.product-card__image');
    var colorEl = card.querySelector('.product-card__color');
    var nameLink = card.querySelector('.product-card__name');
    if (img && img.dataset.originalSrc) {
      img.src = img.dataset.originalSrc;
      img.srcset = img.dataset.originalSrcset || '';
    }
    if (colorEl && colorEl.dataset.originalText) colorEl.textContent = colorEl.dataset.originalText;
    if (nameLink && nameLink.dataset.originalHref) nameLink.href = nameLink.dataset.originalHref;
  }, true);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.featured-collection');
      if (section) initFeaturedCollection(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-backup"]) return;
  try {
    
(function() {
  document.querySelectorAll('[data-footer-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      if (window.innerWidth > 768) return;
      var expanded = this.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-footer-toggle]').forEach(function(t) {
        t.setAttribute('aria-expanded', 'false');
      });
      this.setAttribute('aria-expanded', String(!expanded));
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-article"]) return;
  try {
    
(function() {
  var btns = document.querySelectorAll('.hart__feedback-btn');
  var thanks = document.querySelector('.hart__feedback-thanks');
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btns.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if (thanks) thanks.style.display = 'block';
    });
  });

  var input = document.querySelector('[data-hart-search]');
  var dropdown = document.querySelector('[data-hart-dropdown]');
  var results = document.querySelector('[data-hart-results]');
  var moreLink = document.querySelector('[data-hart-more]');
  var moreQuery = document.querySelector('[data-hart-more-query]');
  if (!input || !dropdown) return;

  var debounce;
  var icon = '<svg class="hart__search-result-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';

  input.addEventListener('input', function() {
    clearTimeout(debounce);
    var q = input.value.trim();
    if (q.length < 2) { dropdown.style.display = 'none'; return; }
    debounce = setTimeout(function() { doSearch(q); }, 250);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { dropdown.style.display = 'none'; input.blur(); }
    if (e.key === 'Enter') { e.preventDefault(); var q = input.value.trim(); if (q) window.location.href = '/pages/help-search?q=' + encodeURIComponent(q); }
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.hart__search-wrap')) dropdown.style.display = 'none';
  });

  function doSearch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=page&resources[limit]=4')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        results.innerHTML = '';
        var pages = data.resources && data.resources.results && data.resources.results.pages || [];
        if (pages.length === 0) {
          results.innerHTML = '<div class="hart__search-no-results">No results found</div>';
          moreLink.style.display = 'none';
          dropdown.style.display = 'block';
          return;
        }
        pages.forEach(function(page) {
          var a = document.createElement('a');
          a.href = page.url;
          a.className = 'hart__search-result';
          a.innerHTML = icon + '<span class="hart__search-result-title">' + escapeHtml(page.title) + '</span>';
          results.appendChild(a);
        });
        moreQuery.textContent = q;
        moreLink.href = '/pages/help-search?q=' + encodeURIComponent(q);
        moreLink.style.display = 'flex';
        dropdown.style.display = 'block';
      });
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-category"]) return;
  try {
    
(function() {
  var input = document.querySelector('[data-hcat-search]');
  var dropdown = document.querySelector('[data-hcat-dropdown]');
  var results = document.querySelector('[data-hcat-results]');
  var moreLink = document.querySelector('[data-hcat-more]');
  var moreQuery = document.querySelector('[data-hcat-more-query]');
  if (!input || !dropdown) return;

  var debounce;
  var icon = '<svg class="hcat__search-result-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';

  input.addEventListener('input', function() {
    clearTimeout(debounce);
    var q = input.value.trim();
    if (q.length < 2) { dropdown.style.display = 'none'; return; }
    debounce = setTimeout(function() { doSearch(q); }, 250);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { dropdown.style.display = 'none'; input.blur(); }
    if (e.key === 'Enter') { e.preventDefault(); var q = input.value.trim(); if (q) window.location.href = '/pages/help-search?q=' + encodeURIComponent(q); }
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.hcat__search-wrap')) dropdown.style.display = 'none';
  });

  function doSearch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=page&resources[limit]=4')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        results.innerHTML = '';
        var pages = data.resources && data.resources.results && data.resources.results.pages || [];
        if (pages.length === 0) {
          results.innerHTML = '<div class="hcat__search-no-results">No results found</div>';
          moreLink.style.display = 'none';
          dropdown.style.display = 'block';
          return;
        }
        pages.forEach(function(page) {
          var a = document.createElement('a');
          a.href = page.url;
          a.className = 'hcat__search-result';
          a.innerHTML = icon + '<span class="hcat__search-result-title">' + escapeHtml(page.title) + '</span>';
          results.appendChild(a);
        });
        moreQuery.textContent = q;
        moreLink.href = '/pages/help-search?q=' + encodeURIComponent(q);
        moreLink.style.display = 'flex';
        dropdown.style.display = 'block';
      });
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-search"]) return;
  try {
    
(function() {
  var params = new URLSearchParams(window.location.search);
  var query = params.get('q') || '';
  var titleEl = document.querySelector('[data-hsearch-title]');
  var resultsEl = document.querySelector('[data-hsearch-results]');
  var emptyEl = document.querySelector('[data-hsearch-empty]');
  var input = document.querySelector('[data-hsearch-input]');

  if (input) {
    input.value = query;
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q) window.location.href = '/pages/help-search?q=' + encodeURIComponent(q);
      }
    });
  }

  if (!query) {
    if (titleEl) titleEl.textContent = 'Search';
    return;
  }

  if (titleEl) titleEl.textContent = 'Searching...';

  fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=page&resources[limit]=10')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var pages = data.resources && data.resources.results && data.resources.results.pages || [];
      var helpPages = pages.filter(function(p) {
        return p.url.indexOf('/pages/help-') > -1;
      });

      if (titleEl) {
        titleEl.textContent = helpPages.length + ' result' + (helpPages.length !== 1 ? 's' : '') + " for '" + query + "'";
      }

      if (helpPages.length === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }

      helpPages.forEach(function(page) {
        var a = document.createElement('a');
        a.href = page.url;
        a.className = 'hsearch__card';

        var body = page.body || '';
        var excerpt = body.replace(/<[^>]*>/g, '').substring(0, 180);
        if (body.length > 180) excerpt += '...';

        a.innerHTML = '<h3 class="hsearch__card-title">' + escapeHtml(page.title) + '</h3>' +
          '<p class="hsearch__card-excerpt">' + escapeHtml(excerpt) + '</p>';
        resultsEl.appendChild(a);
      });
    });

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["her-set"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initHerSet(section) {
    var button = section.querySelector('[data-her-set-add]');
    if (!button) return;

    button.addEventListener('click', function() {
      var variantsRaw = button.getAttribute('data-variants');
      if (!variantsRaw) return;

      var variantIds;
      try {
        variantIds = JSON.parse(variantsRaw);
      } catch(e) {
        return;
      }

      if (!variantIds || variantIds.length === 0) return;

      var items = variantIds.map(function(id) {
        return { id: id, quantity: 1 };
      });

      var originalText = button.textContent;
      button.textContent = 'ADDING...';
      button.classList.add('her-set__button--adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart error');
        return response.json();
      })
      .then(function() {
        button.textContent = 'ADDED ✓';
        button.classList.remove('her-set__button--adding');
        button.classList.add('her-set__button--added');

        setTimeout(function() {
          button.textContent = originalText;
          button.classList.remove('her-set__button--added');
        }, 2000);
      })
      .catch(function() {
        button.textContent = originalText;
        button.classList.remove('her-set__button--adding');
      });
    });
  }

  document.querySelectorAll('.her-set').forEach(initHerSet);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.her-set');
      if (section) initHerSet(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initInstaFeed(section) {
    var id = section.dataset.sectionId;
    var track = section.querySelector('[data-insta-track="' + id + '"]');
    var prev = section.querySelector('[data-insta-prev="' + id + '"]');
    var next = section.querySelector('[data-insta-next="' + id + '"]');
    if (!track || !prev || !next) return;

    var items = track.children;
    var idx = 0;

    function getVisible() {
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 999) return 5;
      return 7;
    }

    function maxIdx() { return Math.max(0, items.length - getVisible()); }

    function updateArrows() {
      prev.classList.toggle('is-disabled', idx <= 0);
      next.classList.toggle('is-disabled', idx >= maxIdx());
    }

    function slide() {
      if (!items.length) return;
      var gap = window.innerWidth <= 768 ? 3 : 4;
      track.style.transform = 'translateX(-' + (idx * (items[0].offsetWidth + gap)) + 'px)';
      updateArrows();
    }

    prev.addEventListener('click', function(e) { e.preventDefault(); idx = Math.max(0, idx - 1); slide(); });
    next.addEventListener('click', function(e) { e.preventDefault(); idx = Math.min(maxIdx(), idx + 1); slide(); });
    window.addEventListener('resize', function() { if (idx > maxIdx()) idx = maxIdx(); slide(); });
    updateArrows();

    var startX = 0;
    track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (diff > 40) { idx = Math.min(maxIdx(), idx + 1); slide(); }
      else if (diff < -40) { idx = Math.max(0, idx - 1); slide(); }
    }, { passive: true });
  }

  document.querySelectorAll('.insta-feed').forEach(initInstaFeed);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.insta-feed');
      if (section) initInstaFeed(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initLatestProducts(section) {
    var sectionId = section.dataset.sectionId;
    var track = section.querySelector('.latest-products__track');
    var prevBtn = section.querySelector('.latest-products__arrow--prev[data-section="' + sectionId + '"]');
    var nextBtn = section.querySelector('.latest-products__arrow--next[data-section="' + sectionId + '"]');

    function getScrollAmount() {
      var card = section.querySelector('.lp-product-card');
      if (card) {
        return (card.offsetWidth + 16) * 3;
      }
      return 600;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (track) {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (track) {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      });
    }
  }

  document.querySelectorAll('.latest-products').forEach(initLatestProducts);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.latest-products');
      if (section) initLatestProducts(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[id^="NewsletterForm-"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value;
      if (!email) return;

      var btn = form.querySelector('.newsletter-signup__btn');
      btn.textContent = '...';
      btn.disabled = true;

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&customer%5Bemail%5D=' + encodeURIComponent(email) + '&customer%5Btags%5D=newsletter'
      }).then(function() {
        form.style.display = 'none';
        var id = form.id.replace('NewsletterForm-', 'NewsletterSuccess-');
        var success = document.getElementById(id);
        if (success) success.style.display = 'block';
      }).catch(function() {
        btn.textContent = 'SUBSCRIBE';
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initProductTabs(section) {
    var sectionId = section.dataset.sectionId;
    var tabs = section.querySelectorAll('.product-tabs__tab[data-section="' + sectionId + '"]');
    var carousels = section.querySelectorAll('.product-tabs__carousel[data-section="' + sectionId + '"]');
    var prevBtn = section.querySelector('.product-tabs__arrow--prev[data-section="' + sectionId + '"]');
    var nextBtn = section.querySelector('.product-tabs__arrow--next[data-section="' + sectionId + '"]');
    var viewAllLink = section.querySelector('.product-tabs__view-all[data-view-all]');

    /* ---------- URL map for VIEW ALL per tab ---------- */
    var viewAllUrls = {};
    tabs.forEach(function(tab) {
      var idx = tab.dataset.tab;
      var settingKey = 'tab_' + idx + '_url';
      /* The URL is baked into the DOM via a data attribute we add at init */
    });

    /* Build url map from the Liquid-rendered data */
    /* We store the urls in hidden data attributes on the carousels */
    var urlMap = {
      '1': section.querySelector('[data-carousel="1"]') ? '{{ section.settings.tab_1_url }}' : '',
      '2': section.querySelector('[data-carousel="2"]') ? '{{ section.settings.tab_2_url }}' : '',
      '3': section.querySelector('[data-carousel="3"]') ? '{{ section.settings.tab_3_url }}' : '',
      '4': section.querySelector('[data-carousel="4"]') ? '{{ section.settings.tab_4_url }}' : ''
    };

    /* ---------- Tab switching ---------- */
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.dataset.tab;

        /* Update active tab */
        tabs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');

        /* Show matching carousel */
        carousels.forEach(function(c) {
          c.classList.remove('active');
          if (c.dataset.carousel === target) {
            c.classList.add('active');
          }
        });

        /* Update VIEW ALL link */
        if (viewAllLink && urlMap[target]) {
          viewAllLink.href = urlMap[target];
          viewAllLink.style.display = '';
        } else if (viewAllLink) {
          viewAllLink.style.display = 'none';
        }
      });
    });

    /* Set initial VIEW ALL visibility */
    if (viewAllLink) {
      var firstActive = section.querySelector('.product-tabs__tab.active');
      if (firstActive) {
        var firstIdx = firstActive.dataset.tab;
        if (!urlMap[firstIdx]) {
          viewAllLink.style.display = 'none';
        }
      }
    }

    /* ---------- Carousel navigation arrows ---------- */
    function getActiveTrack() {
      var activeCarousel = section.querySelector('.product-tabs__carousel.active');
      return activeCarousel ? activeCarousel.querySelector('.product-tabs__track') : null;
    }

    function getScrollAmount() {
      var card = section.querySelector('.pt-card');
      if (card) {
        var gap = 12;
        return (card.offsetWidth + gap) * 3;
      }
      return 700;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var track = getActiveTrack();
        if (track) {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var track = getActiveTrack();
        if (track) {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        }
      });
    }

    /* ---------- Quick Add — expand sizes on trigger click ---------- */
    section.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = trigger.closest('[data-quick-add-wrap]');
        if (wrap) {
          wrap.classList.toggle('is-expanded');
        }
        return;
      }

      /* ---------- Size button — AJAX add to cart ---------- */
      var sizeBtn = e.target.closest('.pt-card__size-btn:not(.pt-card__size-btn--disabled)');
      if (sizeBtn && sizeBtn.dataset.variantId) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = sizeBtn.dataset.variantId;
        var originalText = sizeBtn.textContent;

        sizeBtn.textContent = '...';
        sizeBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }]
          })
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function() {
          sizeBtn.textContent = 'ADDED';
          sizeBtn.classList.add('pt-card__size-btn--added');
          setTimeout(function() {
            sizeBtn.textContent = originalText;
            sizeBtn.classList.remove('pt-card__size-btn--added');
            sizeBtn.disabled = false;
          }, 1200);

          /* Dispatch cart update event for theme cart drawers */
          document.dispatchEvent(new CustomEvent('cart:updated'));

          /* Optional: update cart count in header */
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEls = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span');
              countEls.forEach(function(el) {
                el.textContent = cart.item_count;
              });
            });
        })
        .catch(function() {
          sizeBtn.textContent = 'ERROR';
          setTimeout(function() {
            sizeBtn.textContent = originalText;
            sizeBtn.disabled = false;
          }, 1500);
        });

        return;
      }
    });

    /* ---------- Close expanded sizes when mouse leaves card ---------- */
    section.addEventListener('mouseleave', function(e) {
      if (e.target.closest && e.target.closest('.pt-card__image-wrap')) {
        var wrap = e.target.closest('.pt-card__image-wrap');
        var qaWrap = wrap.querySelector('[data-quick-add-wrap]');
        if (qaWrap) {
          /* Small delay so user can move between trigger and sizes */
          setTimeout(function() {
            if (!wrap.matches(':hover')) {
              qaWrap.classList.remove('is-expanded');
            }
          }, 150);
        }
      }
    }, true);
  }

  /* ---------- Init all instances ---------- */
  document.querySelectorAll('.product-tabs').forEach(initProductTabs);

  /* ---------- Shopify Theme Editor support ---------- */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.product-tabs');
      if (section) initProductTabs(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    function nukePaymentElements() {
      var productDetails = document.querySelectorAll('.product-details');
      productDetails.forEach(function(details) {
        details.querySelectorAll('iframe, shopify-payment-terms, [id*="shopify-installments"], shopify-accelerated-checkout, shopify-buy-now-button, .shopify-cleanslate, [class*="trustBar"], [class*="badges"]').forEach(function(el) {
          el.remove();
        });
        details.querySelectorAll('div').forEach(function(div) {
          if (div.querySelector('iframe') || (div.shadowRoot && div.shadowRoot.querySelector('iframe'))) {
            div.remove();
          }
        });
        details.querySelectorAll('ul').forEach(function(ul) {
          if (!ul.className || ul.className.indexOf('product-details') === -1) {
            var hasPaymentContent = ul.querySelector('img, svg, [class*="payment"], [class*="icon"]');
            if (hasPaymentContent || ul.matches('form + ul, form ~ ul')) {
              ul.remove();
            }
          }
        });
        details.querySelectorAll('img').forEach(function(img) {
          var alt = (img.alt || '').toLowerCase();
          var src = (img.src || '').toLowerCase();
          if (alt.match(/visa|mastercard|klarna|apple.?pay|amex|ideal|paypal|payment/) ||
              src.match(/visa|mastercard|klarna|apple.?pay|amex|ideal|paypal|payment/)) {
            var parent = img.closest('ul, div, li');
            if (parent && parent !== details) parent.remove();
            else img.remove();
          }
        });
      });
    }

    nukePaymentElements();
    setTimeout(nukePaymentElements, 300);
    setTimeout(nukePaymentElements, 800);
    setTimeout(nukePaymentElements, 2000);
    setTimeout(nukePaymentElements, 4000);

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.closest && node.closest('.product-details')) {
            var tag = node.tagName.toLowerCase();
            if (tag === 'iframe' || tag === 'shopify-payment-terms' || tag === 'shopify-accelerated-checkout' || tag === 'shopify-buy-now-button') {
              node.remove();
              continue;
            }
            if (node.querySelector && node.querySelector('iframe')) {
              node.remove();
              continue;
            }
            var cls = (node.className || '').toString().toLowerCase();
            if (cls.indexOf('trustbar') !== -1 || cls.indexOf('badges') !== -1 || cls.indexOf('payment') !== -1 || cls.indexOf('cleanslate') !== -1) {
              node.remove();
            }
          }
        }
      }
    });
    var productPage = document.querySelector('.product-page');
    if (productPage) {
      observer.observe(productPage, { childList: true, subtree: true });
    }

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);

    var sections = document.querySelectorAll('.product-page');

    sections.forEach(function(section) {
      var sectionId = section.dataset.sectionId;
      var pageData = (window.__productPageData && window.__productPageData[sectionId]) || {};
      var slides = section.querySelectorAll('.product-gallery__slide');
      var prevBtn = section.querySelector('[data-gallery-prev]');
      var nextBtn = section.querySelector('[data-gallery-next]');
      var swipeTrack = section.querySelector('[data-swipe-track]');
      var mobThumbs = section.querySelectorAll('[data-mob-thumb]');
      var currentIndex = 0;
      var totalSlides = slides.length;
      var sizeSelected = false;

      var scrollbarFill = section.querySelector('[data-scrollbar-thumb]');

      if (scrollbarFill && totalSlides > 1) {
        scrollbarFill.style.width = (100 / totalSlides) + '%';
      }

      function updateScrollbarRealtime() {
        if (!scrollbarFill || !swipeTrack || totalSlides <= 1) return;
        var maxScroll = swipeTrack.scrollWidth - swipeTrack.offsetWidth;
        if (maxScroll <= 0) return;
        var progress = swipeTrack.scrollLeft / maxScroll;
        var maxTranslate = totalSlides - 1;
        scrollbarFill.style.transform = 'translate3d(' + (progress * maxTranslate * 100) + '%, 0, 0)';
      }

      function updateNavButtons(index) {
        if (prevBtn) prevBtn.style.display = index > 0 ? '' : 'none';
        if (nextBtn) nextBtn.style.display = index < totalSlides - 1 ? '' : 'none';
      }
      updateNavButtons(0);

      function updateMobileThumbs(index) {
        mobThumbs.forEach(function(t) { t.classList.remove('product-gallery__mobile-thumb--active'); });
        if (mobThumbs[index]) mobThumbs[index].classList.add('product-gallery__mobile-thumb--active');
      }

      function goToMobileSlide(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;
        currentIndex = index;
        if (swipeTrack) {
          swipeTrack.scrollTo({ left: index * swipeTrack.offsetWidth, behavior: 'smooth' });
        }
        updateMobileThumbs(index);
        updateNavButtons(index);
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goToMobileSlide(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToMobileSlide(currentIndex + 1); });

      mobThumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          goToMobileSlide(parseInt(this.dataset.mobThumb, 10));
        });
      });

      if (swipeTrack) {
        var scrollTimeout;
        swipeTrack.addEventListener('scroll', function() {
          updateScrollbarRealtime();
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(function() {
            var slideWidth = swipeTrack.offsetWidth;
            if (slideWidth > 0) {
              var newIndex = Math.round(swipeTrack.scrollLeft / slideWidth);
              if (newIndex !== currentIndex) {
                currentIndex = newIndex;
                updateMobileThumbs(currentIndex);
                updateNavButtons(currentIndex);
              }
            }
          }, 50);
        });
      }

      /* ---- Info drawer ---- */
      var drawer = section.querySelector('[data-pdp-drawer]');
      var drawerOverlay = section.querySelector('[data-drawer-overlay]');

      if (drawer && drawerOverlay) {
        document.body.appendChild(drawerOverlay);
        document.body.appendChild(drawer);
      }

      var drawerTabs = drawer ? drawer.querySelectorAll('[data-drawer-tab]') : [];
      var drawerPanels = drawer ? drawer.querySelectorAll('[data-drawer-panel]') : [];

      function openDrawer(tabKey) {
        if (!drawer) return;
        drawerTabs.forEach(function(t) { t.classList.toggle('is-active', t.dataset.drawerTab === tabKey); });
        drawerPanels.forEach(function(p) { p.classList.toggle('is-active', p.dataset.drawerPanel === tabKey); });
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        drawerOverlay.classList.add('is-visible');
        document.body.classList.add('pdp-drawer-open');
        var drawerBody = drawer.querySelector('[data-drawer-body]');
        if (drawerBody) drawerBody.scrollTop = 0;
      }

      function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawerOverlay.classList.remove('is-visible');
        document.body.classList.remove('pdp-drawer-open');
      }

      section.querySelectorAll('[data-drawer-open]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          openDrawer(this.dataset.drawerOpen);
        });
      });

      if (drawer) {
        drawer.querySelector('[data-drawer-close]').addEventListener('click', closeDrawer);
        drawerTabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            var key = this.dataset.drawerTab;
            drawerTabs.forEach(function(t) { t.classList.toggle('is-active', t.dataset.drawerTab === key); });
            drawerPanels.forEach(function(p) { p.classList.toggle('is-active', p.dataset.drawerPanel === key); });
            var drawerBody = drawer.querySelector('[data-drawer-body]');
            if (drawerBody) drawerBody.scrollTop = 0;
          });
        });
      }
      if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

      var whatsMySize = document.querySelector('[data-open-model-tab]');
      if (whatsMySize) {
        whatsMySize.addEventListener('click', function(e) {
          e.preventDefault();
          openDrawer('model');
        });
      }

      var unitToggle = drawer ? drawer.querySelector('[data-unit-toggle]') : null;
      if (unitToggle) {
        var showingCm = true;
        unitToggle.addEventListener('click', function() {
          showingCm = !showingCm;
          unitToggle.textContent = showingCm ? 'in' : 'cm';
          var measures = drawer.querySelectorAll('[data-measurements] .pdp-drawer__measure');
          measures.forEach(function(el) {
            el.textContent = showingCm ? el.getAttribute('data-cm') : el.getAttribute('data-in');
          });
        });
      }

      /* ---- Variant data ---- */
      var variantsEl = section.querySelector('[data-product-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var hasSingleVariant = pageData.productHasSingleVariant || false;
      var hasSizeOption = pageData.productHasSizeOption !== undefined ? pageData.productHasSizeOption : true;
      if (!hasSizeOption) sizeSelected = true;

      /* ---- Add to bag button logic ---- */
      var addBtn = section.querySelector('.product-details__add-btn');
      var stickyBtn = document.querySelector('[data-sticky-add-btn]');

      var sizeError = section.querySelector('#SizeError-' + sectionId);

      function updateAddButton() {
        if (!addBtn) return;

        if (hasSingleVariant) {
          sizeSelected = true;
          var v = variants[0];
          if (v && v.available) {
            addBtn.disabled = false;
            setAddBtnState('cart');
          } else {
            addBtn.disabled = true;
            setAddBtnState('soldout');
          }
          updateStickyBar();
          return;
        }

        if (!sizeSelected) {
          var anyAvailable = false;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].available) { anyAvailable = true; break; }
          }
          if (anyAvailable) {
            addBtn.disabled = false;
            setAddBtnState('cart');
          } else {
            addBtn.disabled = true;
            setAddBtnState('soldout');
          }
          updateStickyBar();
          return;
        }

        var opts = getSelectedOptions();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (opts[j] && v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) {
            var idInput = section.querySelector('input[name="id"]');
            if (idInput) idInput.value = v.id;
            if (v.available) {
              addBtn.disabled = false;
              setAddBtnState('cart');
            } else {
              addBtn.disabled = true;
              setAddBtnState('soldout');
            }
            updateStickyBar();
            return;
          }
        }
      }

      var addSpinnerSvg = '<svg class="product-details__add-spinner" width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7.5" stroke="currentColor" stroke-width="1.5" stroke-dasharray="36 12" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 9 9" to="360 9 9" dur="0.7s" repeatCount="indefinite"/></circle></svg>';
      var addCartIconSvg = '';
      var addCartBagSvg = '<svg class="product-details__add-bag" width="20" height="18" viewBox="0 0 26 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M1.5 2h3l1 4h16v8H8L5.5 6" stroke-width="1.8" stroke-linejoin="miter" stroke-linecap="square"/><circle cx="10" cy="17.5" r="1.5" fill="currentColor" stroke="none"/><circle cx="18.5" cy="17.5" r="1.5" fill="currentColor" stroke="none"/></svg>';

      function getCurrentPrice() {
        var priceEl = section.querySelector('.product-details__price-current');
        return priceEl ? priceEl.textContent.trim() : '';
      }

      function setAddBtnState(state) {
        if (!addBtn) return;
        if (state === 'cart') {
          addBtn.innerHTML = '<span data-add-text>ADD TO CART</span>' + addCartBagSvg;
          addBtn.classList.remove('product-details__add-btn--soldout');
        } else if (state === 'soldout') {
          addBtn.innerHTML = '<span data-add-text>SOLD OUT</span>';
          addBtn.classList.add('product-details__add-btn--soldout');
        } else if (state === 'loading') {
          addBtn.innerHTML = addSpinnerSvg;
        }
      }

      addBtn.addEventListener('click', function() {
        if (!sizeSelected) {
          if (sizeError) sizeError.classList.add('is-visible');
          var allSizeBtns = section.querySelectorAll('.product-details__size-btn');
          allSizeBtns.forEach(function(b) { b.classList.add('product-details__size-btn--error'); });
          return;
        }
        if (sizeError) sizeError.classList.remove('is-visible');
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;

        var idInput = section.querySelector('input[name="id"]');
        if (!idInput) return;
        var variantId = parseInt(idInput.value);

        addBtn.classList.add('is-loading');
        setAddBtnState('loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function(r) {
          if (!r.ok) throw new Error('Add failed');
          return r.json();
        }).then(function(data) {
          addBtn.classList.remove('is-loading');
          setAddBtnState('cart');
          if (window.CartDrawer && data && data.items) {
            var item = data.items[0];
            var parts = (item.variant_title || '').split(' / ');
            var color = parts[0] ? CartDrawer._mapColor(parts[0], item.product_title) : '';
            CartDrawer.showToast({
              key: item.key,
              image: item.image ? item.image.replace(/(\.[^.]+)$/, '_240x$1') : '',
              rawName: item.product_title,
              name: item.product_title,
              color: color,
              size: parts[1] || '',
              price: CartDrawer._formatMoney(item.price)
            });
          }
        }).catch(function() {
          addBtn.classList.remove('is-loading');
          setAddBtnState('cart');
        });
      });

      function updateStickyBar() {
        if (!stickyBtn) return;
        var stickyText = stickyBtn.querySelector('[data-sticky-text]');
        var stickyIcon = stickyBtn.querySelector('svg');
        if (addBtn && addBtn.classList.contains('product-details__add-btn--soldout')) {
          if (stickyText) stickyText.textContent = 'SOLD OUT';
          if (stickyIcon) stickyIcon.style.display = 'none';
          stickyBtn.classList.add('product-sticky-bar__btn--soldout');
        } else {
          if (stickyText) stickyText.textContent = 'ADD TO CART';
          if (stickyIcon) stickyIcon.style.display = '';
          stickyBtn.classList.remove('product-sticky-bar__btn--soldout');
        }
      }

      function getSelectedOptions() {
        var options = [];
        section.querySelectorAll('[data-option-index]').forEach(function(group) {
          var idx = parseInt(group.dataset.optionIndex);
          var active = group.querySelector('.product-details__swatch--active, .product-details__size-btn--active');
          if (active) options[idx] = active.dataset.optionValue;
        });
        return options;
      }

      function updateSelectedVariant() {
        var opts = getSelectedOptions();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (opts[j] && v.options[j] !== opts[j]) { match = false; break; }
          }
          if (match) {
            var idInput = section.querySelector('input[name="id"]');
            if (idInput) idInput.value = v.id;

            /* Update price display */
            var priceEl = section.querySelector('#ProductPrice-' + sectionId);
            if (priceEl) {
              var priceHtml = '';
              if (v.compare_at_price && v.compare_at_price > v.price) {
                var discountPct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
                priceHtml += '<span class="product-details__price-compare">' + formatMoney(v.compare_at_price) + '</span>';
                priceHtml += '<span class="product-details__price-current product-details__price-current--sale">' + formatMoney(v.price) + '</span>';
                priceHtml += '<span class="product-details__price-off">' + discountPct + '% OFF</span>';
              } else {
                priceHtml += '<span class="product-details__price-current">' + formatMoney(v.price) + '</span>';
              }
              priceHtml += '<a href="#trustpilotreviews" class="product-details__review-link" onclick="event.preventDefault();var t=document.getElementById(\'trustpilotreviews\');if(t){var y=t.getBoundingClientRect().top+window.pageYOffset-400;window.scrollTo({top:y,behavior:\'smooth\'});}"><span class="product-details__review-stars">★★★★★</span><span class="product-details__review-count">70+ reviews</span></a>';
              priceEl.innerHTML = priceHtml;
            }

            /* Update split-the-cost amounts */
            var splitSection = section.querySelector('[data-split-section]');
            if (splitSection) {
              var k3 = splitSection.querySelector('[data-split-klarna]');
              if (k3) k3.textContent = formatMoney(Math.round(v.price / 3));
            }

            if (v.available) {
              if (sizeSelected) {
                addBtn.disabled = false;
                setAddBtnState('cart');
              }
            } else {
              addBtn.disabled = true;
              setAddBtnState('soldout');
            }
            updateStickyBar();
            return;
          }
        }
      }

      function formatMoney(cents) {
        var a = cents / 100;
        var f = window.__mf || {p:'',s:'',t:',',d:'.'};
        if (f.zd) { var _i = Math.round(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, f.t); return f.p + _i + f.s; }
        var p = a.toFixed(2).split('.');
        var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.t);
        return f.p + i + f.d + p[1] + f.s;
      }

      /* ---- Size button click ---- */
      var sizeBtns = section.querySelectorAll('.product-details__size-btn');
      var notifyModal = document.getElementById('NotifyModal-' + sectionId);

      sizeBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (this.dataset.oos === 'true') return;
          var parent = this.closest('.product-details__sizes');
          parent.querySelectorAll('.product-details__size-btn').forEach(function(b) {
            b.classList.remove('product-details__size-btn--active');
            b.classList.remove('product-details__size-btn--error');
          });
          this.classList.add('product-details__size-btn--active');
          sizeSelected = true;
          if (sizeError) sizeError.classList.remove('is-visible');
          var selectedLabel = section.querySelector('[data-selected-size]');
          if (selectedLabel) selectedLabel.textContent = this.dataset.optionValue;
          updateSelectedVariant();
          updateAddButton();
        });
      });

      section.querySelectorAll('[data-oos-bell]').forEach(function(bell) {
        bell.addEventListener('click', function() {
          openNotifyModal(this.dataset.oosBell);
        });
      });

      function openNotifyModal(sizeValue) {
        if (!notifyModal) return;

        var sizeDisplay = notifyModal.querySelector('.notify-modal__size-val');
        if (sizeDisplay) sizeDisplay.textContent = sizeValue;

        var sizesContainer = notifyModal.querySelector('.notify-modal__sizes');
        if (sizesContainer) {
          sizesContainer.innerHTML = '';
          section.querySelectorAll('.product-details__size-btn[data-oos="true"]').forEach(function(oosBtn) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'notify-modal__size-pill';
            pill.textContent = oosBtn.dataset.optionValue;
            if (oosBtn.dataset.optionValue === sizeValue) pill.classList.add('notify-modal__size-pill--active');
            pill.addEventListener('click', function() {
              sizesContainer.querySelectorAll('.notify-modal__size-pill').forEach(function(p) { p.classList.remove('notify-modal__size-pill--active'); });
              this.classList.add('notify-modal__size-pill--active');
              if (sizeDisplay) sizeDisplay.textContent = this.textContent;
            });
            sizesContainer.appendChild(pill);
          });
        }

        requestAnimationFrame(function() {
          notifyModal.classList.add('is-open');
        });
      }

      function closeNotifyModal() {
        if (!notifyModal) return;
        notifyModal.classList.remove('is-open');
      }

      if (notifyModal) {
        notifyModal.querySelectorAll('[data-notify-close]').forEach(function(el) {
          el.addEventListener('click', closeNotifyModal);
        });
        var notifyBtn = notifyModal.querySelector('.notify-modal__btn');
        var notifyInput = notifyModal.querySelector('.notify-modal__input');
        if (notifyBtn) {
          notifyBtn.addEventListener('click', function() {
            var email = notifyInput.value.trim();
            var activePill = notifyModal.querySelector('.notify-modal__size-pill--active');
            notifyInput.style.borderColor = '';
            if (!activePill) return;
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
              notifyInput.style.borderColor = '#d32f2f';
              notifyInput.setAttribute('placeholder', 'Enter a valid email');
              notifyInput.focus();
              return;
            }
            var selectedSize = activePill.textContent.trim();
            var variantsEl = section.querySelector('[data-product-variants]');
            if (!variantsEl) return;
            var variants = JSON.parse(variantsEl.textContent);
            var variantId = null;
            for (var i = 0; i < variants.length; i++) {
              if (variants[i].options.indexOf(selectedSize) > -1 && !variants[i].available) {
                variantId = variants[i].id;
                break;
              }
            }
            if (!variantId) return;
            var notifyOrigHTML = notifyBtn.innerHTML;
            notifyBtn.style.pointerEvents = 'none';
            notifyBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7.5" stroke="currentColor" stroke-width="1.5" stroke-dasharray="36 12" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 9 9" to="360 9 9" dur="0.7s" repeatCount="indefinite"/></circle></svg>';
            fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UFZH2j', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: { data: { type: 'profile', attributes: { email: email } } }
                  },
                  relationships: {
                    variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
                  }
                }
              })
            }).then(function(r) {
              notifyBtn.style.pointerEvents = '';
              if (r.ok || r.status === 202) {
                notifyBtn.textContent = 'YOU\'RE ON THE LIST';
                notifyInput.value = '';
                notifyInput.setAttribute('placeholder', 'Email address');
                setTimeout(closeNotifyModal, 1400);
                setTimeout(function() { notifyBtn.innerHTML = notifyOrigHTML; }, 1600);
              } else {
                notifyBtn.textContent = 'SOMETHING WENT WRONG';
                setTimeout(function() { notifyBtn.innerHTML = notifyOrigHTML; }, 2500);
              }
            }).catch(function() {
              notifyBtn.style.pointerEvents = '';
              notifyBtn.textContent = 'SOMETHING WENT WRONG';
              setTimeout(function() { notifyBtn.innerHTML = notifyOrigHTML; }, 2500);
            });
          });
          notifyInput.addEventListener('input', function() {
            notifyInput.style.borderColor = '';
          });
        }
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && notifyModal.classList.contains('is-open')) closeNotifyModal();
        });
      }

      /* ---- Color swatch click + hover ---- */
      var swatches = section.querySelectorAll('.product-details__swatch');
      var colorNameEl = section.querySelector('#ProductColorName-' + sectionId);

      function formatColorDisplay(swatch) {
        var name = swatch.getAttribute('title') || '';
        var num = swatch.getAttribute('data-color-tint') || '';
        return num ? 'Nº ' + num + ' ' + name : name;
      }

      var activeSwatch = section.querySelector('.product-details__swatch--active');
      var activeName = activeSwatch ? formatColorDisplay(activeSwatch) : (colorNameEl ? colorNameEl.textContent : '');

      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          if (this.classList.contains('product-details__swatch--active')) {
            e.preventDefault();
            return;
          }
          if (this.tagName === 'BUTTON') {
            var parent = this.closest('.product-details__color');
            parent.querySelectorAll('.product-details__swatch').forEach(function(s) {
              s.classList.remove('product-details__swatch--active');
            });
            this.classList.add('product-details__swatch--active');
            activeName = formatColorDisplay(this);
            if (colorNameEl) colorNameEl.textContent = activeName;
            updateSelectedVariant();
          }
        });
      });
      var swatchContainer = section.querySelector('.product-details__swatches');
      if (swatchContainer) {
        swatchContainer.addEventListener('mouseenter', function(e) {
          var swatch = e.target.closest('.product-details__swatch');
          if (swatch && colorNameEl) colorNameEl.textContent = formatColorDisplay(swatch);
        }, true);
        swatchContainer.addEventListener('mouseleave', function(e) {
          var swatch = e.target.closest('.product-details__swatch');
          if (swatch && colorNameEl) colorNameEl.textContent = activeName;
        }, true);
      }

      /* ---- Sticky bar: scroll to size selector or submit ---- */
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function() {
          if (!sizeSelected) {
            var sizeSection = section.querySelector('.product-details__sizes');
            if (sizeSection) {
              sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
              if (sizeError) sizeError.classList.add('is-visible');
              section.querySelectorAll('.product-details__size-btn').forEach(function(b) {
                b.classList.add('product-details__size-btn--error');
              });
            }
            return;
          }
          var idInput = section.querySelector('input[name="id"]');
          if (!idInput) return;
          var variantId = parseInt(idInput.value);
          if (stickyBtn.classList.contains('product-sticky-bar__btn--soldout')) return;
          if (stickyBtn.classList.contains('is-loading')) return;

          var stickyText = stickyBtn.querySelector('[data-sticky-text]');
          var stickyPrice = stickyBtn.querySelector('[data-sticky-price]');
          var stickyDot = stickyBtn.querySelector('.product-sticky-bar__dot');
          var stickyIconEl = stickyBtn.querySelector('svg');
          stickyBtn.classList.add('is-loading');
          if (stickyText) stickyText.textContent = '';
          if (stickyPrice) stickyPrice.style.display = 'none';
          if (stickyDot) stickyDot.style.display = 'none';
          if (stickyIconEl) stickyIconEl.outerHTML = addSpinnerSvg;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          }).then(function(r) {
            if (!r.ok) throw new Error('Add failed');
            return r.json();
          }).then(function(data) {
            stickyBtn.classList.remove('is-loading');
            if (stickyText) stickyText.textContent = 'ADD TO CART';
            if (stickyPrice) stickyPrice.style.display = '';
            if (stickyDot) stickyDot.style.display = '';
            var newIcon = document.createElement('span');
            newIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>';
            var spinner = stickyBtn.querySelector('.product-details__add-spinner');
            if (spinner) spinner.replaceWith(newIcon.firstChild);
            updateStickyBar();
            if (window.CartDrawer && data && data.items) {
              var item = data.items[0];
              var pts = (item.variant_title || '').split(' / ');
              CartDrawer.showToast({
                key: item.key,
                image: item.image ? item.image.replace(/(\.[^.]+)$/, '_240x$1') : '',
                rawName: item.product_title,
                name: item.product_title,
                color: pts[0] ? CartDrawer._mapColor(pts[0], item.product_title) : '',
                size: pts[1] || '',
                price: CartDrawer._formatMoney(item.price)
              });
            }
          }).catch(function() {
            stickyBtn.classList.remove('is-loading');
            if (stickyText) stickyText.textContent = 'ADD TO CART';
            if (stickyPrice) stickyPrice.style.display = '';
            if (stickyDot) stickyDot.style.display = '';
            var newIcon = document.createElement('span');
            newIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>';
            var spinner = stickyBtn.querySelector('.product-details__add-spinner');
            if (spinner) spinner.replaceWith(newIcon.firstChild);
            updateStickyBar();
          });
        });

        var stickyBar = document.querySelector('[data-sticky-bar]');
        if (stickyBar && addBtn && 'IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                stickyBar.classList.remove('is-visible');
              } else {
                var rect = addBtn.getBoundingClientRect();
                if (rect.top < 0) {
                  stickyBar.classList.add('is-visible');
                }
              }
            });
          }, { threshold: 0 });
          observer.observe(addBtn);
        }
      }

      /* ---- Add button: scroll to sizes if no size selected ---- */
      if (addBtn) {
        addBtn.addEventListener('click', function(e) {
          if (this.hasAttribute('data-no-size-selected')) {
            e.preventDefault();
            var sizeSection = section.querySelector('.product-details__sizes');
            if (sizeSection) {
              sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        });
      }

      /* ---- Initialize button state ---- */
      if (hasSingleVariant) {
        sizeSelected = true;
      }
      updateAddButton();

      /* ---- Wishlist button ---- */
      var wishlistBtn = section.querySelector('.product-details__wishlist');
      if (wishlistBtn) {
        var productHandle = '{{ product.handle }}';
        var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        if (wishlist.indexOf(productHandle) !== -1) {
          wishlistBtn.classList.add('is-wishlisted');
        }
        wishlistBtn.addEventListener('click', function() {
          wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
          var idx = wishlist.indexOf(productHandle);
          if (idx === -1) {
            wishlist.push(productHandle);
            this.classList.add('is-wishlisted');
          } else {
            wishlist.splice(idx, 1);
            this.classList.remove('is-wishlisted');
          }
          localStorage.setItem('wishlist', JSON.stringify(wishlist));
        });
      }
    });

    // Social proof number formatting
    var spEl = document.getElementById('sp-count');
    if (spEl) {
      var n = parseInt(spEl.getAttribute('data-count'), 10);
      try {
        var lang = spEl.closest('.sp-pill') ? '{{ fmt_locale }}' : 'en-US';
        spEl.textContent = new Intl.NumberFormat(lang).format(n);
      } catch(e) { spEl.textContent = n; }
    }

  })();

  // Recommendations slider
  (function() {
    var track = document.querySelector('[data-rec-track]');
    var prev = document.querySelector('[data-rec-prev]');
    var next = document.querySelector('[data-rec-next]');
    if (!track || !prev || !next) return;

    function getScrollAmount() {
      var card = track.querySelector('.bs-product-card');
      if (!card) return 600;
      if (window.innerWidth <= 768) return card.offsetWidth;
      return card.offsetWidth * 3;
    }

    prev.addEventListener('click', function(e) {
      e.preventDefault();
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function(e) {
      e.preventDefault();
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-color"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSBC(section) {
    var id = section.dataset.sectionId;
    var track = section.querySelector('[data-sbc-track="' + id + '"]');
    var prev = section.querySelector('[data-sbc-prev="' + id + '"]');
    var next = section.querySelector('[data-sbc-next="' + id + '"]');
    if (!track || !prev || !next) return;

    var scrollAmount = 300;

    function updateArrows() {
      prev.classList.toggle('is-disabled', track.scrollLeft <= 5);
      next.classList.toggle('is-disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 5);
    }

    prev.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows);
    updateArrows();
  }

  document.querySelectorAll('.shop-by-color').forEach(initSBC);

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('.shop-by-color');
      if (section) initSBC(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"] && !Shopify.designMode) return;
  try {
    
(function() {
  var popup = document.getElementById('WelcomePopup');
  if (!popup) return;

  if (localStorage.getItem('wp_popup_done')) return;
  var dismissed = localStorage.getItem('wp_popup_dismissed');
  if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

  var delay = parseInt(popup.dataset.wpDelay || '3') * 1000;

  setTimeout(function() {
    popup.style.display = 'block';
    document.body.style.overflow = 'hidden';
    initScratch();
  }, delay);

  function closePopup() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    localStorage.setItem('wp_popup_dismissed', Date.now().toString());
  }

  popup.querySelectorAll('[data-wp-close]').forEach(function(el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.style.display === 'block') closePopup();
  });

  function goToStep(n) {
    popup.querySelectorAll('[data-wp-step]').forEach(function(s) {
      s.classList.remove('wp-popup__step--active');
    });
    var step = popup.querySelector('[data-wp-step="' + n + '"]');
    if (step) step.classList.add('wp-popup__step--active');
  }

  popup.querySelectorAll('[data-wp-goto]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      goToStep(this.dataset.wpGoto);
    });
  });

  /* Email form */
  var emailForm = document.getElementById('WpEmailForm');
  if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('WpEmail').value;
      if (!email) return;

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&customer%5Bemail%5D=' + encodeURIComponent(email) + '&customer%5Btags%5D=popup-signup'
      }).catch(function() {});

      localStorage.setItem('wp_popup_done', '1');
      goToStep(3);
    });
  }

  /* Copy code */
  var copyBtn = document.getElementById('WpCopyBtn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      var code = document.getElementById('WpCode');
      if (code) {
        navigator.clipboard.writeText(code.textContent.trim()).then(function() {
          copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
          setTimeout(function() {
            copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>';
          }, 2000);
        });
      }
    });
  }

  /* Scratch card */
  function initScratch() {
    var canvas = document.getElementById('ScratchCanvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var rect = canvas.getBoundingClientRect();
    var w = rect.width;
    var h = rect.height;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.scale(dpr, dpr);

    /* Base gold */
    var g1 = ctx.createLinearGradient(0, 0, w, h);
    g1.addColorStop(0, '#d6cba5');
    g1.addColorStop(0.25, '#c7b98e');
    g1.addColorStop(0.5, '#d9ceaa');
    g1.addColorStop(0.75, '#c4b68b');
    g1.addColorStop(1, '#d2c69e');
    ctx.fillStyle = g1;
    ctx.fillRect(0, 0, w, h);

    /* Metallic sheen */
    var g2 = ctx.createLinearGradient(0, 0, w * 0.7, h * 0.5);
    g2.addColorStop(0, 'rgba(230,220,190,0.35)');
    g2.addColorStop(0.5, 'rgba(255,250,230,0.15)');
    g2.addColorStop(1, 'rgba(200,185,145,0.25)');
    ctx.fillStyle = g2;
    ctx.fillRect(0, 0, w, h);

    /* Foil grain texture */
    for (var i = 0; i < 8000; i++) {
      var bright = Math.random();
      if (bright > 0.7) {
        ctx.fillStyle = 'rgba(240,235,210,' + (Math.random() * 0.08) + ')';
      } else if (bright > 0.3) {
        ctx.fillStyle = 'rgba(190,178,140,' + (Math.random() * 0.1) + ')';
      } else {
        ctx.fillStyle = 'rgba(160,148,110,' + (Math.random() * 0.08) + ')';
      }
      var sz = Math.random() * 2.5 + 0.5;
      ctx.fillRect(Math.random() * w, Math.random() * h, sz, Math.random() > 0.5 ? 1 : sz);
    }

    /* Brushed metal lines */
    ctx.globalAlpha = 0.04;
    for (var j = 0; j < 80; j++) {
      ctx.strokeStyle = j % 2 === 0 ? '#fff' : '#a09060';
      ctx.lineWidth = Math.random() * 0.8 + 0.2;
      ctx.beginPath();
      var yy = Math.random() * h;
      ctx.moveTo(0, yy + Math.random() * 4);
      ctx.lineTo(w, yy + Math.random() * 4 - 2);
      ctx.stroke();
    }
    ctx.globalAlpha = 1.0;

    /* No pre-scratch marks */

    var totalPixels = canvas.width * canvas.height;
    var scratching = false;
    var revealed = false;
    var lastPos = null;
    var moveCount = 0;
    var brushR = 28;
    var hint = document.getElementById('ScratchHint');

    function getPos(e) {
      var r = canvas.getBoundingClientRect();
      var t = e.touches ? e.touches[0] : e;
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    }

    function drawLine(from, to) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = brushR * 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(from.x, from.y);
      ctx.lineTo(to.x, to.y);
      ctx.stroke();
      ctx.globalCompositeOperation = 'source-over';
    }

    function drawDot(pos) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, brushR, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
    }

    function checkPercent() {
      var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var cleared = 0;
      for (var i = 3; i < pixels.length; i += 16) {
        if (pixels[i] === 0) cleared++;
      }
      var total = Math.floor(pixels.length / 16);
      return cleared / total;
    }

    function scratch(pos) {
      if (hint) { hint.style.display = 'none'; hint = null; }
      if (lastPos) {
        drawLine(lastPos, pos);
      } else {
        drawDot(pos);
      }
      lastPos = pos;
      moveCount++;
      if (moveCount % 8 === 0) {
        var pct = checkPercent();
        if (pct > 0.45) revealCard();
      }
    }

    function revealCard() {
      if (revealed) return;
      revealed = true;
      canvas.style.opacity = '0';
      canvas.style.pointerEvents = 'none';
      setTimeout(function() {
        canvas.style.display = 'none';
        var claimBtn = document.getElementById('WpClaimBtn');
        if (claimBtn) claimBtn.style.display = 'flex';
      }, 500);
    }

    canvas.addEventListener('mousedown', function(e) {
      scratching = true; lastPos = null; scratch(getPos(e));
    });
    canvas.addEventListener('mousemove', function(e) {
      if (scratching) scratch(getPos(e));
    });
    canvas.addEventListener('mouseup', function() { scratching = false; lastPos = null; });
    canvas.addEventListener('mouseleave', function() { lastPos = null; });
    canvas.addEventListener('mouseenter', function(e) {
      if (e.buttons === 1) { scratching = true; scratch(getPos(e)); }
    });

    canvas.addEventListener('touchstart', function(e) {
      e.preventDefault(); scratching = true; lastPos = null; scratch(getPos(e));
    }, { passive: false });
    canvas.addEventListener('touchmove', function(e) {
      e.preventDefault(); if (scratching) scratch(getPos(e));
    }, { passive: false });
    canvas.addEventListener('touchend', function() { scratching = false; lastPos = null; });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
